import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Helper} from "@/plugins/helper";
import {NavigationGuardNext} from "vue-router/types/router";
import {store} from "@/store";
import app from "@/main";
import {ekranAcikMiTazeleyerek, ENGEL_TAZELEME_ALT_SINIR_MS, ozetBayatMi, rotaOzelligi, TAZELEME_ALT_SINIR_MS} from "@/utils/lisansKisit";
import {PathToProduct} from "@/enum/Product";
import {kapananSayfadanCik} from "@/utils/sayfaErisimi";
import { applyTheme } from '@/plugins/vuetify';
import {takipListeBaglaminiRotayaGoreDogrula} from "@/helpers/TakipListeGezintiHelper";
import { SENKRON_KAPI_TAZELEME_ARALIGI_MS, senkronRotasiYonlendirmesi } from '@/utils/senkronKapisi';

Vue.use(VueRouter)

const clearCache = (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
    localStorage.removeItem('accessToken');
    sessionStorage.clear();
    next();
}

const kullaniciIzinKontrol = async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
    try {
        if (store.getters.accessToken) {
            let user = store.getters.userData;
            if (!user.id) {
                let tenantList = await store.dispatch("getTenantList");
                store.commit('setTenantId', tenantList[0].tenant_id)
                user = await app.$http.get("/api/v1/ben");
                store.commit('setUser', user);
            } else {
                if (store.state.tenantList.length === 0) {
                    await store.dispatch("getTenantList");
                }
                // Deploy oncesi acilmis oturumlarda sessionStorage'daki user'da
                // `lisans_durum` yoktur; yenileme/demo bari o sekmede hic gorunmez.
                // Bir kereye mahsus tazelenir (alan geldiginde -- null olsa bile --
                // kosul bir daha saglanmaz).
                if (user.lisans_durum === undefined) {
                    user = await app.$http.get("/api/v1/ben");
                    store.commit('setUser', user);
                // DEV-2113 — kural özeti yoksa (deploy öncesi açılmış oturum) ya da
                // sonraki geçiş anı geçmişse /ben tazelenir: sayfa yenilense de eski
                // özet kalmaz. En fazla beş dakikada bir (tarayıcı saati kaymış olabilir).
                } else if (ozetBayatMi(user.ozellik_durumu)) {
                    try {
                        user = await store.dispatch('ozellikDurumunuTazele', {enAzAralikMs: TAZELEME_ALT_SINIR_MS});
                    } catch (e) {
                        // Tazeleme hatası oturumu kapatmaz: eldeki (bayat) özetle devam
                        // edilir; engellemeyi zaten sunucu yapar.
                    }
                }
            }
            // DEV-2113 — geçiş anı geldiğinde sayfa geçişi olmasa da /ben tazelensin.
            store.dispatch('ozellikTazelemesiniKur');
            let urunPath = to.path.split('/')[1];
            // @ts-ignore
            const urun = PathToProduct[urunPath];
            // DEV-2113 — kapi artik "lisans gecerli mi" degil, "bu urunun ekranlari
            // acik mi" sorusunu soruyor. KISITLI donemde kullanici ICERI ALINIR;
            // hangi islemi yapabilecegine sunucu karar verir, ekran yalnizca gosterir.
            // Onceden suresi dolmus kullanici dogrudan erisim-yok'a dusuyordu -- bu
            // yuzden backend duzelse bile kullanici duvara carpiyordu.
            // Kapali gorunuyorsa once ozet tazelenir (lisans yenilenmis olabilir).
            if (await ekranAcikMiTazeleyerek(
                () => helper.lisansEkranlariAcikMi(urun),
                () => store.dispatch('ozellikDurumunuTazele', {enAzAralikMs: ENGEL_TAZELEME_ALT_SINIR_MS})
            )) {
                // DEV-2113 — sayfa yeni bir özelliğe bağlıysa (meta.ozellik) ve özellik bu
                // büroda kapalıysa sayfa açılmaz, "Bu özellik büronuzda aktif değil" sayfası
                // açılır. Önce özet tazelenir: özellik az önce açılmış olabilir. Uçları
                // sunucunun özellik kapısı ayrıca korur.
                const ozellik = rotaOzelligi(to.matched.map((kayit) => kayit.meta));
                if (ozellik !== null && !(await ekranAcikMiTazeleyerek(
                    () => helper.ozellikAcikMi(ozellik),
                    () => store.dispatch('ozellikDurumunuTazele', {enAzAralikMs: ENGEL_TAZELEME_ALT_SINIR_MS})
                ))) {
                    next({path: ProgramPaths.ozellikKapali, query: {urun: urunPath}});
                    return;
                }
                user = store.getters.userData;
                // @ts-ignore
                let meta: { isAuthenticationRequired: boolean, izinKey: string | string[] } = to.meta;
                // izinKey dizi ise TÜM izinler gerekli; tek string ise tek izin (geriye dönük uyumlu).
                // İzin listesi yalnız yetki gereken rotada okunur (eski kısa devre korunur).
                const izinVar = (key: string) => meta.isAuthenticationRequired && !!user.roles[0].permissions.find((permission: any) => permission.name === key);
                const izinliMi = Array.isArray(meta.izinKey)
                    ? meta.izinKey.every((key: string) => izinVar(key))
                    : izinVar(meta.izinKey);
                if (!meta.isAuthenticationRequired || (meta.isAuthenticationRequired && izinliMi)) {
                    // Otomatik sorgu kapısı (DEV-2603): sessionStorage'daki kullanıcı bayat
                    // olabilir; e-İcraPro'ya girişte kapı değeri en çok yarım saatte bir
                    // sunucudan tazelenir (`/ben` ağır: sayfa yenilemesi sıfır istek kalsın;
                    // bu guard'da ya da girişte `/ben` az önce çekildiyse hiç istek gitmez).
                    // Beklenmez (menü reaktif güncellenir) ve hata verse bile gezinmeyi etkilemez.
                    if ("/" + urunPath === ProgramPaths.eicrapro)
                        store.dispatch("senkronDurumunuTazele", {enAzAralikMs: SENKRON_KAPI_TAZELEME_ARALIGI_MS});
                    next();
                } else
                    next(ProgramPaths.erisimYok);
            } else if (helper.lisansDurumu(urun) === 'sure_bitti' || helper.lisansDurumu(urun) === 'yok') {
                // Lisans kaynakli engel: ciplak 403 yerine durumu ve yenileme
                // adimini anlatan ekran. Hangi urunden gelindigi query ile
                // tasinir; menu orada da o urunun kalemlerini PASIF gosterir
                // (kullanici modullerin var oldugunu gormeye devam etmeli).
                next({path: ProgramPaths.lisansDurumu, query: {urun: urunPath}});
            } else
                next(ProgramPaths.erisimYok);
            //TODO: özel satınal ekranı olabilir
        } else {
            console.error('Token not found.');
            if (to.path != ProgramPaths.giris)
                next(ProgramPaths.giris);
        }
    } catch (e) {
        localStorage.removeItem('accessToken');
        sessionStorage.clear();
        console.error(e);
        Vue.prototype.$toast.error('Hata: ' + e.message);
        if (to.path != ProgramPaths.giris)
            next(ProgramPaths.giris);
    }
};

/**
 * Otomatik sorgu kapısı (DEV-2603, karar 20.10.2026): plan ekranı rotası. Önce
 * olağan kullanıcı/lisans kontrolü koşar; o bir yönlendirme isterse (giriş, erişim
 * yok) aynen uygulanır. Geçişe izin verdiyse kapı kontrol edilir: kapalıysa
 * e-İcraPro ana sayfasına yönlendirilir. Menü kalemi gizli olsa da adresi yazarak
 * ya da yer imiyle gelen kullanıcı buradan dönmelidir.
 */
const senkronRotasiKapisi = (to: Route, from: Route, next: NavigationGuardNext<Vue>) =>
    kullaniciIzinKontrol(to, from, async (...args: any[]) => {
        if (args.length > 0) {
            (next as any)(...args);
            return;
        }
        const yonlendirme = await senkronRotasiYonlendirmesi(store);
        if (yonlendirme) next(yonlendirme);
        else next();
    });

const routes: RouteConfig[] = [
    {
        path: '/',
        redirect: ProgramPaths.giris,
        meta: {
            isAuthenticationRequired: false,
        },
    },
    {
        path: '/giris',
        component: () => import('@/views/common/HomeView.vue'),
        beforeEnter: clearCache,
        meta: {
            isAuthenticationRequired: false,
        },
    },
    {
        path: '/giris-kontrol',
        component: () => import('@/views/common/LoginCallback.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro,
        component: () => import('@/views/common/YapimAsamasinda.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/buro-bilgileri',
        component: () => import('@/views/ofispro/BuroListeView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'buro-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/buro/:id',
        component: () => import('@/views/ofispro/BuroDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'buro-detay'
        }
    },
    {
        path: ProgramPaths.ofispro + '/personel/:id',
        component: () => import('@/views/ofispro/PersonelDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'buro-calisan-bilgisi-detay'
        }
    },
    {
        path: ProgramPaths.ofispro + '/vekaletler',
        component: () => import('@/views/ofispro/VekaletListeView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'vekalet-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/muvekkil-excel-aktar',
        component: () => import('@/views/ofispro/MuvekkilExcelAktarView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            // Ekran hem vekalet oluşturur hem müvekkil ekler → her iki yetki de şart (uçlar muvekkil-ekle ister).
            izinKey: ['vekalet-ekle', 'muvekkil-ekle']
        }
    },
    {
        path: ProgramPaths.ofispro + '/vekalet/:id',
        component: () => import('@/views/ofispro/VekaletDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'vekalet-detay'
        }
    },
    {
        path: ProgramPaths.ofispro + '/raporlar',
        component: () => import('@/views/ofispro/RaporListeView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'rapor-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/rapor/:id',
        component: () => import('@/views/ofispro/RaporDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'rapor-detay'
        }
    },
    {
        path: ProgramPaths.ofispro + '/dilekceler',
        component: () => import('@/views/ofispro/DilekceView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'dilekce-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/kasa',
        component: () => import('@/views/ofispro/KasaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'kasa-modulu'
        }
    },
    //TODO:ÇALIŞMADIĞI İÇİN KAPATILDI 1@sebo
    /*
    {
        path: ProgramPaths.ofispro + '/klasorler',
        component: () => import('@/views/ofispro/KlasorlerView.vue'),
        meta: {
            isAuthenticationRequired: true,
        }
    },*/
    {
        path: ProgramPaths.ofispro + '/ajanda',
        component: () => import('@/views/ofispro/AjandaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'ajanda-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/icw-aktar',
        component: () => import('@/views/ofispro/AktarView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'aktar-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/kullanici-izinleri',
        component: () => import('@/views/ofispro/OfisTercihlerView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'tercih-modulu'
        }
    },
    {
        path: ProgramPaths.ofispro + '/hesap-bilgileri',
        component: () => import('@/views/ofispro/HesapBilgileriView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/muvekkil/:id',
        component: () => import('@/views/ofispro/MuvekkilDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'muvekkil-detay'
        }
    },
    {
        path: ProgramPaths.ofispro + '/islem-kaydi',
        component: () => import('@/views/ofispro/LogView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'islem-kaydi'
        }
    },
    {
        path: ProgramPaths.ofispro + '/hesaplamalar',
        name: 'ofispro-hesaplamalar',
        component: () => import('@/views/ofispro/Hesaplamalar.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'buro-modulu',
        }
    },
    {
        path: ProgramPaths.ofispro + '/dosya-raporlama-tipleri',
        component: () => import('@/views/ofispro/raporlama/DosyaRaporlamaTipleriView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/genel-istatistikler',
        component: () => import('@/views/ofispro/raporlama/GenelRaporlamaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'genel-istatistikler'
        }
    },{
        path: ProgramPaths.ofispro + '/tahsilatlar',
        component: () => import('@/views/ofispro/raporlama/TahsilatlarView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },{
        path: ProgramPaths.ofispro + '/karsilastirmali-tahsilatlar',
        component: () => import('@/views/ofispro/raporlama/KarsilastirmaliRaporlamaView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },{
        path: ProgramPaths.ofispro + '/takip-ve-tahsilat-raporu',
        component: () => import('@/views/ofispro/raporlama/TakipVeTahsilatRaporlamaView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/aktar-detay/:id',
        component: () => import('@/views/ofispro/AktarDetay.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/aktarilan-detay/:id',
        component: () => import('@/views/ofispro/AktarilanDosyaDetay.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/aktarilmayan-detay/:id',
        component: () => import('@/views/ofispro/AktarilmayanDosyaDetay.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ofispro + '/uyarilar',
        component: () => import('@/views/ofispro/OfisProUyarilar.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'uyarilar-modulu'
        }
    },
    {
        path: ProgramPaths.icrapro,
        component: () => import('@/views/common/YapimAsamasinda.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.icrapro + '/borclu/:id',
        component: () => import('@/views/icrapro/BorcluDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'borclu-detay'
        }
    },
    {
        path: ProgramPaths.icrapro + '/takip-alt-tip/:id',
        component: () => import('@/views/icrapro/TakipAltTipView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'takip-alt-tip-detay'
        }
    },
    {
        path: ProgramPaths.icrapro + '/takipler',
        component: () => import('@/views/icrapro/TakipListView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'takip-listesi'
        }
    },
    {
        path: ProgramPaths.icrapro + '/takip/:id',
        component: () => import('@/views/icrapro/TakipDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'takip-detay'
        }
    },
    {
        path: ProgramPaths.icrapro + '/takip-ekle',
        component: () => import('@/views/icrapro/TakipEkleView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'takip-ac'
        }
    },
    {
        path: ProgramPaths.icrapro + '/takip-ekle/:id',
        component: () => import('@/views/icrapro/TakipEkleView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'takip-detay'
        }
    },
    {
        path: ProgramPaths.icrapro + '/tercihler',
        component: () => import('@/views/icrapro/TercihlerView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'tercihler-modulu'
        }
    },
    {
        path: ProgramPaths.icrapro + '/toplu-isler',
        component: () => import('@/views/icrapro/TopluIslerView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'toplu-xml-indir'
        }
    },
    {
        path: ProgramPaths.icrapro + '/toplu-not',
        component: () => import('@/views/icrapro/TopluNotAlma.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'toplu-not'
        }
    },

    {
        path: ProgramPaths.icrapro + '/toplu-excel',
        component: () => import('@/views/icrapro/TopluExcelTakip.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'toplu-excel-takip'
        }
    },
    {
        path: ProgramPaths.icrapro + '/toplu-takip-tarihi',
        component: () => import('@/views/icrapro/TopluTakipTarihi.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'toplu-takip-tarihi'
        }
    },
    {
        path: ProgramPaths.icrapro + '/toplu-takip-durumu',
        component: () => import('@/views/icrapro/TopluTakipDurumu.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'toplu-takip-durumu'
        }
    },
    {
        path: ProgramPaths.icrapro + '/toplu-is',
        component: () => import('@/views/icrapro/TopluIsAtama.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
            izinKey: 'toplu-is'
        }
    },
    {
        path: ProgramPaths.icrapro + '/hesaplayici',
        component: () => import('@/views/icrapro/HesaplayiciView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'faiz-hesaplama-modulu'
        }
    },
    {
        path: ProgramPaths.icrapro + '/vekalet-ucreti-hesaplayici',
        component: () => import('@/views/icrapro/VekaletUcretiHesaplayiciView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: true,
            izinKey: 'faiz-hesaplama-modulu'
        }
    },
    {
        path: ProgramPaths.eicrapro,
        component: () => import('@/views/eicrapro/IslemlerView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/deneme-tahtasi',
        component: () => import('@/views/eicrapro/Servisler.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/evrak-gonder',
        component: () => import('@/views/eicrapro/EvrakGonderView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/harc-masraf-odeme',
        component: () => import('@/views/eicrapro/HarcMasrafOdeView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/kisi-kurum-sorgula',
        component: () => import('@/views/eicrapro/KisiKurumSorgulaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/senkron-plani',
        component: () => import('@/views/eicrapro/SenkronPlanView.vue'),
        beforeEnter: senkronRotasiKapisi,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/islemler',
        component: () => import('@/views/eicrapro/IslemlerView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-odeme',
        component: () => import('@/views/eicrapro/MtsOdemeView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-hazirla',
        component: () => import('@/views/eicrapro/TakipHazirlaBetaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-ac',
        component: () => import('@/views/eicrapro/TakipAcView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-takip-hazirla',
        component: () => import('@/views/eicrapro/MtsTakipHazirlaBetaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-takip-ac',
        component: () => import('@/views/eicrapro/MtsTakipAcView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-hash-list',
        component: () => import('@/views/eicrapro/HashListView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-tebligat-gonder',
        component: () => import('@/views/eicrapro/MtsTebligatView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-sorgula',
        component: () => import('@/views/eicrapro/TakipSorgulaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/vekil-sorgula',
        component: () => import('@/views/eicrapro/VekilSorgulaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/toplu-haciz-talebi-gonder',
        component: () => import('@/views/eicrapro/TopluHacizHazirlaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/toplu-tebligat-talebi-gonder',
        component: () => import('@/views/eicrapro/TopluTebligatHazirlaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/toplu-genel-talep-gonder',
        component: () => import('@/views/eicrapro/TopluGenelTalepHazirlaView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/hazir-evrak-gonder',
        component: () => import('@/views/eicrapro/HazirEvrakGonderView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/evrak-indir',
        component: () => import('@/views/eicrapro/EvrakIndirView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/makbuz-indir',
        component: () => import('@/views/eicrapro/MakbuzIndirView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-hazirla-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TakipHazirlaIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-ac-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TakipAcIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-takip-hazirla-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MtsTakipHazirlaIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-takip-hazirla-beta-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MtsTakipHazirlaBetaIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-takip-ac-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MtsTakipAcIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/takip-sorgula-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TakipSorgulaIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/evrak-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/EvrakGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/hazir-evrak-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/HazirEvrakGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/makbuz-indir-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MakbuzIndirIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/genel-talep-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TopluGenelTalepGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/tebligat-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TopluTebligatGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/haciz-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/TopluHacizGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/harc-masraf-ode-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/HarcMasrafOdeIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-ode-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MtsOdemeIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/mts-tebligat-gonder-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/MtsTebligatGonderIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.eicrapro + '/evrak-indir-detay/:id',
        component: () => import('@/views/eicrapro/islem-detay/EvrakIndirIslemDetayView.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.davapro,
        component: () => import('@/views/common/YapimAsamasinda.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.arabulucupro,
        component: () => import('@/views/common/YapimAsamasinda.vue'),
        beforeEnter: kullaniciIzinKontrol,
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.lisansDurumu,
        component: () => import('@/views/common/LisansDurumuView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: ProgramPaths.ozellikKapali,
        component: () => import('@/views/common/OzellikKapaliView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: '/erisim-yok',
        component: () => import('@/views/common/YasakView.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/common/NotFound.vue'),
        meta: {
            isAuthenticationRequired: false,
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL || '/',
    routes
});

const helper = new Helper();
// DEV-2113 — sayfa açıkken lisans biterse ya da özellik büroya kapanırsa kullanıcı orada
// kalmaz: özet her tazelendiğinde açık sayfa muhafızla aynı kuralla yeniden denetlenir.
// İzleyici ilk geçiş bitince kurulur: store ile router birbirini içe aktarıyor, bu modül
// yüklenirken store henüz hazır olmayabilir (modül düzeyinde kurmak açılışta çökertirdi).
const kapananSayfaIzleyicisiniKur = () => {
    kapananSayfadanCik(router, store, {
        ekranlarAcikMi: (urun) => helper.lisansEkranlariAcikMi(urun),
        lisansDurumu: (urun) => helper.lisansDurumu(urun),
        ozellikAcikMi: (anahtar) => helper.ozellikAcikMi(anahtar),
    });
};
router.onReady(kapananSayfaIzleyicisiniKur, kapananSayfaIzleyicisiniKur);
router.beforeEach(async (to, from, next) => {
    if (store.getters.accessToken && to.path == ProgramPaths.giris)
        next(ProgramPaths.ofispro);
    next();
});

router.afterEach((to, from) => {
    const themeKey = resolveRouteTheme(to);
    applyTheme(themeKey);
    // DEV-2857: kart listeden/karttan değil de başka yerden açıldıysa eski liste bağlamını bırak
    takipListeBaglaminiRotayaGoreDogrula(to, from);
});

const PATH_THEME_MAP: Record<string, string> = {
    ofispro: 'ofispro',
    icrapro: 'icrapro',
    eicrapro: 'eicrapro',
};

function resolveRouteTheme(to: Route): string {
    const metaTheme = (to.meta && (to.meta as any).app) as string | undefined;
    if (typeof metaTheme === 'string' && metaTheme.length > 0) {
        return metaTheme;
    }

    const programKey = to.path.split('/').filter(Boolean)[0];
    if (programKey && PATH_THEME_MAP[programKey]) {
        return PATH_THEME_MAP[programKey];
    }

    return 'default';
}

export default router
